import {
  GET_BOOKING_DEPARTURE_LOADING,
  GET_BOOKING_DEPARTURE_FAILED,
  GET_BOOKING_DEPARTURE_SUCCESS,
} from "../types"
  
  const initialState = {
    bookings: [],
    loading: false,
    error: false,
    empty: false,
  }

  export default function (state = initialState, action) {
    switch (action.type) {
      case GET_BOOKING_DEPARTURE_LOADING:
        return {
          ...state,
          loading: true,
          error: false,
          empty: false,
          bookings: [],
        }
      case GET_BOOKING_DEPARTURE_FAILED:
        return {
          ...state,
          loading: false,
          error: true,
          empty: false,
          bookings: [],
        }
      case GET_BOOKING_DEPARTURE_SUCCESS:
        return {
          ...state,
          loading: false,
          error: false,
          empty: action.payload.length == 0,
          bookings: action.payload,
        }
      default:
        return state
    }
  }
  